export enum RoleEnum {
  ADM =  "ADM",
  FINANCEIRO =  "FINANCEIRO",
  USUARIO =  "USUARIO",
  COORDENADOR =  "COORDENADOR",
  ASPLAN_FORCA = "ASPLAN_FORCA",
  CADASTRAR_CONSULTA_CIRAST = "CADASTRAR_CONSULTA_CIRAST",
  CADASTRAR_CLINICA_CIRAST = "CADASTRAR_CLINICA_CIRAST",
  GERAR_RELATORIO_CIRAST = "GERAR_RELATORIO_CIRAST",
}
